import DlPageHeader from "./main.vue"

/* istanbul ignore next */
DlPageHeader.install = function(Vue) {
  Vue.component(DlPageHeader.name, DlPageHeader)
}

export default DlPageHeader
